export const ORDERS_ENDPOINT = '/api/v3/orders/';

export const getOrderHistoryPath = (customerId, pageIndex, limit) =>
  customerId
    ? `/api/v3/customers/${customerId}/order-history/?page=${pageIndex}&limit=${limit}`
    : null;
